import { TrendChart } from '../../components/charts/TrendChart';
import { SectionCard } from '../../components/SectionCard';
import { StateFeedback } from '../../components/StateFeedback';
import { protoColors } from '../../theme/tokens';
import { Grid } from './styles';
import useEvolution from './useEvolution';

export function Evolution(): JSX.Element {
  const { evolution, loading, error } = useEvolution();

  const labels = evolution.map((point) => point.month);
  const slaSeries = evolution.map((point) => point.slaPct);
  const csatSeries = evolution.map((point) => point.avgCsat);
  const demandsSeries = evolution.map((point) => point.totalDemands);
  const deliveredSeries = evolution.map((point) => point.deliveredOnTime);
  const approvalSeries = evolution.map((point) => point.approvalPct);

  return (
    <StateFeedback
      loading={loading}
      error={error}
      empty={evolution.length === 0}
    >
      <Grid>
        <SectionCard title="SLA por mês" subtitle="% de OS no prazo">
          <TrendChart
            labels={labels}
            series={[
              { label: 'SLA', color: protoColors.purple, data: slaSeries },
            ]}
          />
        </SectionCard>

        <SectionCard title="CSAT médio por mês" subtitle="Escala 0–5">
          <TrendChart
            labels={labels}
            series={[
              { label: 'CSAT', color: protoColors.info, data: csatSeries },
            ]}
          />
        </SectionCard>

        <SectionCard
          title="Demandas × entregues no prazo"
          subtitle="Volume mensal"
        >
          <TrendChart
            labels={labels}
            series={[
              {
                label: 'Total de demandas',
                color: protoColors.textMuted,
                data: demandsSeries,
              },
              {
                label: 'Entregues no prazo',
                color: protoColors.success,
                data: deliveredSeries,
              },
            ]}
          />
        </SectionCard>

        <SectionCard
          title="Aprovação 1ª revisão por mês"
          subtitle="% sobre o total de demandas"
        >
          <TrendChart
            labels={labels}
            series={[
              {
                label: 'Aprovação 1ª revisão',
                color: protoColors.success,
                data: approvalSeries,
              },
            ]}
          />
        </SectionCard>
      </Grid>
    </StateFeedback>
  );
}
